import { BackButton } from "@/components/common/BackButton";
import { useEffect } from "react";
import { AlertTriangle, RefreshCw } from "lucide-react";
import { useRouteError } from "react-router-dom";

import { Button } from "@/components/ui/button";

/**
 * 予期しない描画エラー時の最終フォールバック。
 *
 * React Router 標準の開発者向けエラー画面やスタックトレースを利用者に
 * 露出せず、安全に再読み込み・ダッシュボード復帰できる導線を提供する。
 */
export function AppRouteError() {
  const error = useRouteError();

  useEffect(() => {
    console.error("Unhandled route error:", error);
  }, [error]);

  return (
    <main className="flex min-h-dvh items-center justify-center bg-slate-50 p-4 sm:p-6">
      <section
        role="alert"
        className="w-full max-w-lg rounded-(--radius-container) border border-slate-200 bg-white p-6 shadow-sm sm:p-8"
      >
        <div className="flex size-12 items-center justify-center rounded-full bg-amber-100 text-amber-700">
          <AlertTriangle aria-hidden="true" className="size-6" />
        </div>
        <h1 className="mt-5 text-xl font-bold text-slate-950">
          画面を表示できませんでした
        </h1>
        <p className="text-sm leading-6 text-slate-600">
          一時的な読み込みエラーが発生しました。画面を再読み込みして、もう一度お試しください。
        </p>
        <div className="mt-6 flex flex-col-reverse gap-2 sm:flex-row">
          <BackButton
            fallbackPath="/dashboard"
            reloadDocument
            className="sm:flex-1"
          >
            ダッシュボードへ戻る
          </BackButton>
          <Button
            type="button"
            className="sm:flex-1"
            onClick={() => window.location.reload()}
          >
            <RefreshCw aria-hidden="true" className="size-4" />
            再読み込み
          </Button>
        </div>
      </section>
    </main>
  );
}
